import { MakeCodeRenderBlocksProvider } from "@microbit/makecode-embed";
import React, { ReactNode } from "react";
import { SanityCodeDocument } from "../../model/common";
import { useDeploymentDetails } from "../../model/deployment";
import { siteLanguageToMakeCodeLanguage } from "../../model/language";

interface EditorEmbedSupportProps {
  document: SanityCodeDocument;
  children: ReactNode;
}

const EditorEmbedSupport = ({
  document,
  children
}: EditorEmbedSupportProps) => {
  const { makecodeVersion } = useDeploymentDetails();
  // It's expensive to load MakeCode so avoid it if we can based on
  // the info calculated in on-create-node.
  const disabled = !Object.values(document.fields.editorLinks).some(
    x => !!x.makecode
  );
  return (
    <MakeCodeRenderBlocksProvider
      disabled={disabled}
      lang={siteLanguageToMakeCodeLanguage(document.language)}
      version={makecodeVersion}
    >
      {children}
    </MakeCodeRenderBlocksProvider>
  );
};

export default EditorEmbedSupport;
